<script>
    let className = '';
    export { className as class };

    export let fluid = false;
    export let narrow = false;
    export let thin = false;
    export let nop = false;
    export let id = undefined;
</script>

<section
    {id}
    class="{fluid
        ? 'w-full max-w-full'
        : narrow
        ? 'container md:max-w-screen-md'
        : thin
        ? 'container max-w-[470px]'
        : 'container'} mx-auto {nop ? '' : 'px-4 md:px-8'} {className}"
>
    <slot />
</section>
